import { render, staticRenderFns } from "./RbuSectionPaginatedList.vue?vue&type=template&id=0489a8e8"
import script from "./RbuSectionPaginatedList.vue?vue&type=script&lang=js"
export * from "./RbuSectionPaginatedList.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionPaginatedList.vue?vue&type=style&index=0&id=0489a8e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports